var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3555 5.46875L10.2148 11.4863H9.00781L8.86133 5.46875H10.3555ZM8.82031 13.332C8.82031 13.1172 8.89062 12.9375 9.03125 12.793C9.17578 12.6445 9.375 12.5703 9.62891 12.5703C9.87891 12.5703 10.0762 12.6445 10.2207 12.793C10.3652 12.9375 10.4375 13.1172 10.4375 13.332C10.4375 13.5391 10.3652 13.7168 10.2207 13.8652C10.0762 14.0098 9.87891 14.082 9.62891 14.082C9.375 14.082 9.17578 14.0098 9.03125 13.8652C8.89062 13.7168 8.82031 13.5391 8.82031 13.332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.8c6386b4493d270d7ab0d1be1bbc0273.svg";
export { ForwardRef as ReactComponent };